import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../helper/global.service';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  servicesData = {
    "servicesList": [{
      "icon" : "assets/icon/embed-red.svg",
      "activeIcon":"assets/icon/embed-white.svg",
      "title" : "Embedded Design",
      "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry"
    },
    {
      "icon" : "assets/icon/rf-red.svg",
      "activeIcon":"assets/icon/rf-white.svg",
      "title" : "RF Based Products",
      "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry"
    },
    {
      "icon" : "assets/icon/system-red.svg",
      "activeIcon":"assets/icon/system-white.svg",
      "title" : "System Architecture",
      "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry"
    },
    {
      "icon" : "assets/icon/mechanical-red.svg",
      "activeIcon":"assets/icon/mechanical-white.svg",
      "title" : "Mechanical Design",
      "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry"
    },{
      "icon" : "assets/icon/pcb-red.svg",
      "activeIcon":"assets/icon/pcb-white.svg",
      "title" : "PCB Artwork Design",
      "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry"
    }]
  }
    
  constructor() { }

  ngOnInit(): void {
    
  }

}
